module.exports = __webpack_public_path__ + "c9dab4bcaa3b93f73d16cb0181c66a04.svg";